<template>
  <div
    :id="tabContentId"
    class="tab-pane"
    :class="{ active: selected }"
    :aria-labelledby="tabId"
  >
    <slot />
  </div>
</template>

<script>
import { camelCase } from 'lodash-es';

export default {
  name: 'AppTab',
  props: {
    label: {
      type: String,
      required: true,
    },
    tabId: {
      type: String,
      default: (props) => camelCase(props.label),
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selected: false,
  }),
  computed: {
    fullTabId() {
      return `tab-${this.tabId}`;
    },
    tabContentId() {
      return `tabcontent-${this.tabId}`;
    },
  },
  mounted() {
    this.$parent.registerTab(this);
  },
  methods: {
    select() {
      this.selected = true;
      this.$emit('tab-selected', this.tabId);
    },
    unselect() {
      this.selected = false;
    },
  },
};
</script>
